// @unocss-include
'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import { useBoundsCssVars } from '../../hooks/useSize.js';
export function PageContent(_a) {
    var { children, fullHeight, noPadding, innerProps, className, scrollable = true } = _a, rest = __rest(_a, ["children", "fullHeight", "noPadding", "innerProps", "className", "scrollable"]);
    const innerRef = useBoundsCssVars(200, undefined, {
        left: '--content-left',
        top: '--content-top',
        width: '--content-width',
        height: '--content-height',
        ready: '--content-ready',
    });
    return (_jsx("div", Object.assign({ className: classNames('layer-components:[grid-area:content] layer-components:max-w-full layer-components:min-w-0 layer-components:w-full layer-components:flex layer-components:flex-col layer-components:items-start layer-components:relative layer-components:flex-1 layer-components:gap-3', { 'layer-variants:overflow-y-auto layer-variants:h-full': scrollable }, className) }, rest, { children: _jsx("div", Object.assign({}, innerProps, { className: classNames('layer-components:w-full layer-components:min-w-0 layer-components:flex layer-components:flex-col layer-components:mb-120px layer-components:px-4 layer-components:py-4 layer-components:flex-1', {
                'layer-variants:flex-1 layer-variants:mb-auto': fullHeight,
                'layer-variants:p-0 layer-variants:sm:p-4': noPadding,
            }, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className), ref: innerRef, children: children })) })));
}
//# sourceMappingURL=PageContent.js.map